import P, { shape } from 'prop-types';
import BoxDataComponent from './BoxDataComponent';

const FrameSummary = ({data}) => 
    (
        <>
            <BoxDataComponent title="Resumo" data={data}/>
        </>
    )

FrameSummary.propTypes = {
    data: P.arrayOf(
      shape({
        id: P.number,
        value: P.string,
      })
    ),
};

FrameSummary.defaultProps = {
    data: null,
};

export default FrameSummary;
